<template>
  <div>
    <div v-show="!isLoaded">
      <Loading ref="loadingSpinner"/>
    </div>
    <div v-show="isLoaded">
      <b-overlay :show="busy" rounded="sm">
        <b-form @submit="SubmitForm">
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col">
                  <label>Wybrany bęben:</label>
                  <v-select label="name" :options="barrels" v-model="form.barrelId" :reduce="(x) => x.id"
                            :disabled="true"></v-select>
                </div>
              </div>
            </div>
            <div class="col">
              <DisplayRecepies ref="displayRecepies" @selectedRecepie="SetNameAndInsertIngridients"/>
            </div>
          </div>
          <hr/>

          <div v-show="form.rawMaterialTypeGroup.length > 0 || form.selectedCouvertures.length > 0">
            <div class="card">
              <div class="card-header">
                <div class="row">
                    <h4>Produkty znajdujące się w kuwerturze</h4>
                    <button type="button" class="btn btn-primary float-right"
                            @click="AddNextPositionToCouvertureGroupList">
                      Dodaj składnik
                    </button>
                </div>
              </div>
              <div class="card-body">
                <IngredientForCouverture v-for="rwTypeGroup in form.rawMaterialTypeGroup" :key="rwTypeGroup.id"
                                         :rawMaterials="rawMaterials" :rawMaterialTypeGroup="rwTypeGroup"
                                         :counter="counter"
                                         :recipeRef="$refs.displayRecepies"/>
              </div>
            </div>

            <div class="card mt-4">
              <div class="card-header">
                <div class="row">
                  <div class="col-8">
                    <h4>Dodane kuwertury</h4>
                  </div>
                  <div class="col-4">
                    <button type="button" class="btn btn-primary float-right" @click="AddCouvertureItem">
                      Dodaj kuwerturę
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body" v-show="form.selectedCouvertures.length > 0">
                <CouvertureIngredient v-for="couverture in form.selectedCouvertures" :key="couverture.id"
                                      :couverture="couverture" @AddExistingCouvertureRemoveItem="RemoveCouvertureItem"/>
              </div>
            </div>

            <div class="row">
              <div class="col align-self-end div-form-buttons-area">
                <button type="submit" class="btn-primary btn">Zapisz</button>
              </div>
            </div>
          </div>
        </b-form>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import Loading from "../../components/Common/Loading";
import IngredientForCouverture from "../Production/IngredientForCouverture";
import DisplayRecepies from "./Shared/DisplayRecipeCoating.vue";
import toastr from "../../mixins/toastr";
import ProductionCommonMethods from "../../mixins/ProductionCommonMethods";
import CouvertureIngredient from "./CouvertureIngredient";
import RawMaterialsMixins from "../../mixins/rawMaterials"
import BarrelMixins from "../../mixins/barrelMixin"
import CouvertureMixins from "../../mixins/couverture"

export default {
  name: "EditCoatingProduct",
  mixins: [toastr, ProductionCommonMethods, RawMaterialsMixins, BarrelMixins, CouvertureMixins],
  components: {
    Loading,
    IngredientForCouverture,
    DisplayRecepies,
    CouvertureIngredient,
  },
  computed: {
    barrels() {
      return this.$store.state.productionHall.barrels;
    },
    rawMaterialTypes() {
      return this.$store.state.couvertureFormData.rawMaterialTypes;
    },
    couvertureRecipes() {
      return this.$store.state.couvertureFormData.recipes;
    },
    coatingRecipes() {
      return this.$store.state.productionHall.recipeCoating;
    },
  },
  beforeMount() {
    this.$store.dispatch("getProductionHallData");
    this.$store.dispatch("getCuvertureFormData");
  },
  mounted() {
    var that = this;
    this.form.barrelId = parseInt(this.$route.params.barrelId);

    this.getAllRawMaterials().then((avaiableRawMaterials) => {
      that.rawMaterials =
          that.CreateAvaiableRawMaterialList(avaiableRawMaterials);
    })

    this.fetchBarrelDetails(this.form.barrelId).then((barrelDetailsRes) => {
      const barrelInfo = barrelDetailsRes.data;

      that.coatingProductId =
          barrelInfo.coatingProducts[0].coatingProductId;

      //Set Recipe Data
      var recipe = that.coatingRecipes.filter(
          (x) => x.id == barrelInfo.coatingProducts[0].recipe.id
      )[0];
      that.$refs.displayRecepies.selectedRecipe = recipe;

      //Set Couvertures and Products
      that.SetNameAndInsertIngridients(barrelInfo);
    })
  },
  data() {
    return {
      busy: false,
      counter: 0,
      isLoaded: false,
      rawMaterials: [],
      selectedRecipe: {},
      coatingProductId: 0,
      form: {
        rawMaterialTypeGroup: [],
        selectedCouvertures: [],
        barrelId: 0,
      },
    };
  },
  methods: {
    GetRawMaterialType(rawMaterilTypeId) {
      return this.rawMaterialTypes.filter((x) => x.id == rawMaterilTypeId)[0];
    },

    SetNameAndInsertIngridients(coatingProduct) {
      this.isLoaded = false;
      this.form.rawMaterialTypeGroup = [];
      this.form.selectedCouvertures = [];

      //Dodanie składników z poza receptury
      // Produkty
      coatingProduct.coatingProducts[0].ingridients.forEach((item) => {
        var productGroup = this.form.rawMaterialTypeGroup.filter(
            (x) => x.rawMaterialType.id == item.rawMaterialTypeId
        );
        //Grupa istnieje
        if (productGroup.length > 0) {
          var product = productGroup[0].rawMaterials.filter(
              (x) => x.selectedRawMaterial.id == item.rawMaterialId
          );
          //Szukanego produkt nie ma na liście
          if (product.length == 0) {
            const selectedRawMaterial = this.rawMaterials.filter(
                (rw) => rw.id == item.rawMaterialId
            )[0]

            productGroup[0].rawMaterials.push({
              id: this.counter,
              selectedRawMaterial: {
                ...selectedRawMaterial,
                maxWeightToUse: selectedRawMaterial.availableWeight + item.weight
              },
              usedWeight: item.weight,
            });
            this.counter = this.counter + 1;
          }
        } else {
          var selectedRawMaterial = this.rawMaterials.filter(
              (rw) => rw.id == item.rawMaterialId
          )[0];
          if (selectedRawMaterial) {
            selectedRawMaterial.maxWeightToUse =
                selectedRawMaterial.availableWeight + item.weight;
          }


          this.form.rawMaterialTypeGroup.push({
            rawMaterialType: this.GetRawMaterialType(item.rawMaterialTypeId),
            rawMaterials: [
              {
                id: this.counter,
                selectedRawMaterial: selectedRawMaterial,
                usedWeight: item.weight,
              },
            ],
            id: this.counter,
          });
          this.counter = this.counter + 1;
        }
      });

      //TODO ustawianie kuwertury
      var that = this;
      coatingProduct.coatingProducts[0].couvertures.forEach((item) => {
        var couverutreOnList = that.form.selectedCouvertures.filter(
            (x) => x.couverture.id == item.couvertureId
        );
        if (couverutreOnList.length == 0) {
          this.getCouverturesOnShelfByRecipeId(item.recipeId).then(
              function (res) {
                let couverture = {
                  couverture: res.data.filter((x) =>
                      x.name.includes(item.couvertureName)
                  )[0],
                  couvertureType: that.couvertureRecipes.filter(
                      (x) => x.id == item.recipeId
                  )[0],
                  id: that.counter,
                  weight: item.weight,
                };
                that.counter = that.counter + 1;
                that.form.selectedCouvertures.push(couverture);
              }
          );
        }
      });

      this.isLoaded = true;
    },

    SubmitForm(evt) {
      var ingredients = [];

      evt.preventDefault();
      var isValid = this.FormValidation();
      var that = this;
      if (isValid) {
        this.busy = true;
        var rawMaterialGroups = this.form.rawMaterialTypeGroup.filter(
            (x) => x.rawMaterialType.id != 0
        );

        rawMaterialGroups.forEach((rwg) => {
          rwg.rawMaterials.forEach((rw) => {
            if (rw.selectedRawMaterial.id) {
              ingredients.push({
                sourceId: rw.selectedRawMaterial.id,
                weight: parseFloat(rw.usedWeight),
                type: 2,
              });
            }
          });
        });

        var couvertures = this.form.selectedCouvertures
            .filter((x) => x.couverture.id)
            .map((x) => ({
              sourceId: x.couverture.id,
              weight: x.weight,
              type: 1,
            }));

        ingredients = ingredients.concat(couvertures);

        this.editCoatingProductInBarell(that.coatingProductId, that.$refs.displayRecepies.selectedRecipe.id, ingredients)
            .then(function () {
              that.DisplaySuccess("Sukces!", "Kuwertura została wyedytowana");
              window.location.href = "/#/Bebny/";
            })
            .catch(function (e) {
              that.DisplayError("Błąd!", "Wystąpił błąd podczas zapisu edycji");
              that.busy = false;
              console.log(e);
            });
      }
    },

    ValidateWeightForRawMaterials() {
      var groups = this.form.rawMaterialTypeGroup;
      for (var i = 0; i < groups.length; i++) {
        var group = groups[i];
        var rawMaterials = group.rawMaterials;

        for (var j = 0; j < rawMaterials.length; j++) {
          var rawMaterialRow = rawMaterials[j];
          var avaiableWeight =
              rawMaterialRow.selectedRawMaterial.maxWeightToUse;
          var usedWeight = parseFloat(rawMaterialRow.usedWeight);

          if (
              usedWeight == undefined ||
              !rawMaterialRow.selectedRawMaterial ||
              rawMaterialRow.selectedRawMaterial.id == 0
          ) {
            var text = rawMaterialRow.selectedRawMaterial.name
                ? "Wpisana waga w produkcie " +
                rawMaterialRow.selectedRawMaterial.fullName +
                " jest nie prawidłowa."
                : "Wpisana waga w jednym z produktów jest nie prawidłowa.";

            this.DisplayError("Bład w kuwerturze", text);

            return false;
          }

          if (
              usedWeight == undefined ||
              usedWeight < 0 ||
              usedWeight > avaiableWeight
          ) {
            this.DisplayError(
                "Bład w produkcie",
                "Wpisana waga w produkcie " +
                rawMaterialRow.selectedRawMaterial.name +
                " jest nie prawidłowa"
            );
            return false;
          }
        }
      }
      return true;
    },

    ValidateWeightForCouverture() {
      var couvertures = this.form.selectedCouvertures;
      for (var i = 0; i < couvertures.length; i++) {
        var couverutreRow = couvertures[i];
        var avaiableWeight = couverutreRow.couverture.totalWeight;
        var usedWeight = couverutreRow.weight;

        if (
            usedWeight == undefined ||
            usedWeight < 0 ||
            usedWeight > avaiableWeight
        ) {
          var text = couverutreRow.couverture.name
              ? "Wpisana waga kuwertury " +
              couverutreRow.couverture.name +
              " jest nie prawidłowa."
              : "Wpisana waga w jednej z kuwertur jest nie prawidłowa.";

          this.DisplayError("Bład w kuwerturze", text);
          return false;
        }
      }
      return true;
    },

    FormValidation() {
      var rawMaterialWeightIsValid = this.ValidateWeightForRawMaterials();
      var couvertureWeightIsValid = this.ValidateWeightForCouverture();
      var isEmptyForm = this.CheckIfFormIsEmpty();

      return (
          rawMaterialWeightIsValid == true &&
          couvertureWeightIsValid == true &&
          isEmptyForm == false
      );
    },

    CheckIfFormIsEmpty() {
      var rawMaterialsCount = this.form.rawMaterialTypeGroup.filter(
          (x) => x.rawMaterials.map((c) => c.rawMaterials).length > 0
      ).length;
      var couvertureCount = this.form.selectedCouvertures.filter(
          (x) => x.couverture.id
      ).length;
      var isEmptyForm = rawMaterialsCount == 0 && couvertureCount == 0;
      if (isEmptyForm) {
        this.DisplayError(
            "Błąd w formularzu",
            "Nie można wysłać pustego formularza"
        );
      }
      return isEmptyForm;
    },
    AddNextPositionToCouvertureGroupList() {
      var rawMaterial = {
        id: this.counter,
        selectedRawMaterial: {
          id: 0,
          name: "",
          availableWeight: 0,
          serialNumber: "",
        },
        usedWeight: 0,
      };
      this.form.rawMaterialTypeGroup.push({
        rawMaterialType: {},
        rawMaterials: [rawMaterial],
        id: this.counter,
      });
      this.counter = this.counter + 1;
    },
    AddCouvertureItem() {
      var couverture = this.CreateCouverture();
      couverture.id = this.counter;
      this.counter = this.counter + 1;
      this.form.selectedCouvertures.push(couverture);
    },
    RemoveCouvertureItem(couvertureId) {
      this.form.selectedCouvertures = this.form.selectedCouvertures.filter(
          (x) => x.id != couvertureId
      );
    },
  },
};
</script>
